<template>
  <div
    :class="computedClasses"
    role="alert"
    aria-live="polite"
    aria-atomic
   
    :aria-hidden="!isInvalid"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  isInvalid?: boolean
}>()

const computedClasses = computed(() => {
  return [
    'text-text-danger text-xs',
    {
      hidden: !props.isInvalid,
      visible: props.isInvalid,
    },
  ]
})
</script>
